import styled from 'styled-components';
import PageTitle from '../components/pageTitle';

import redBlob from '../images/blob_red.png';
import yellowBlob from '../images/blob_yellow.png';
import greenBlob from '../images/blob_green.png';
import blueBlob from '../images/blob_blue.png';
import orangeBlob from '../images/blob_orange.png';
import yellowWave from '../images/yellow_wave.png';

const EmailLink = styled.a`
    text-decoration: none;
    &:link { color: var(--black); }
    &:visited { color: var(--dark-green); }
    &:link:active, :visited:active { var(--dark-blue); }
    &:hover {
      color: var(--dark-blue);
    }
`;

const Bullet = styled.img`
  width: 28px;
  height: 28px;
  pointer-events: none;

  @media (max-width: 800px) {
    width: 18px;
    height: 18px;
  }
`;

const TitleWave = styled.img`
  width: 200px;
  pointer-events: none;

  @media (max-width: 800px) {
    width: 150px;
  }
`;

const QAContainer = styled.div`
  @media (max-width: 800px) {
    max-width: 590px;
    width: 96%;
    margin: 0 auto;
  }
`;

const Question = styled.div`
  display: flex;
  font-size: 24px;
  line-height: 24px;
  gap: 24px;
  margin-bottom: 16px;

  @media (max-width: 800px) {
    font-size: 20px;
  }
`;

const Answer = styled.div`
  font-size: 18px;
  line-height: 1.5;
  margin-left: 48px;

  @media (max-width: 800px) {
    font-size: 16px;
    margin-left: 40px;
  }
`;

const questions = [
  {
    bullet: redBlob,
    question: 'Jak do nas dołączyć?',
    answer: (
      <>
        Napisz do nas na{' '}
        <EmailLink href="mailto:drops.sluzew@dominikanie.pl">
          drops.sluzew@dominikanie.pl
        </EmailLink>
        {'.'}
      </>
    ),
  },
  {
    bullet: yellowBlob,
    question: 'Kiedy można do nas dołączyć?',
    answer:
      'Zapraszamy do dołączania do nas na początku września i lutego. Jednak śmiało odzywajcie się do nas już wcześniej - podamy Wam więcej szczegółów.',
  },
  {
    bullet: greenBlob,
    question: 'Czy można do nas dołączyć, jeśli nie ma się dzieci?',
    answer: 'Tak, zapraszamy!',
  },
  {
    bullet: blueBlob,
    question: 'Co z dziećmi w trakcie spotkań?',
    answer:
      'W trakcie naszych spotkań sobotnich dzieci do lat 3 są pod opieką rodziców, zaś wszystkie starsze dzieci zostają pod opieką opiekunek w pobliskich salkach w klasztorze, podzielone na dwie grupy zgodnie z wiekiem. Na spotkania biblijne oraz spotkania dla kobiet i mężczyzn zapraszamy bez dzieci. Na rekolekcje wyjeżdżamy całymi rodzinami i korzystamy z pomocy opiekunek w trakcie niektórych punktów programu.',
  },
  {
    bullet: orangeBlob,
    question: 'Czy spotkania coś kosztują?',
    answer:
      'Nie. Jedyne koszty to zrzutka na opiekę dla dzieci raz na semestr (dobrowolna dla  tych, którzy dzieci nie mają) oraz wyjazdy na rekolekcje.',
  },
];

export default function Contact() {
  return (
    <>
      <PageTitle>
        Pytania?
        <TitleWave src={yellowWave} />
      </PageTitle>
      {questions.map(({ bullet, question, answer }) => (
        <QAContainer key={question}>
          <Question>
            <Bullet src={bullet} />
            {question}
          </Question>
          <Answer>{answer}</Answer>
        </QAContainer>
      ))}
    </>
  );
}
